function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getNullLogger } from '@uniformdev/common';
import { getSubscriptionManager } from '@uniformdev/optimize-common-sitecore';
import { getSitecorePersonalizationRuleManager } from '../ruleManagers/sitecore';
import { getSitecoreContextDataReader } from './contextReaders';
import { getNullTestManager } from '../testManagers';
;
;
/**
 * Gets a Sitecore personalization manager.
 * @param args
 */
export function getSitecorePersonalizationManager(args) {
  var _this = this;
  var id = "SC_PERS_MGR";
  var _args$disabled = args.disabled,
    disabled = _args$disabled === void 0 ? false : _args$disabled,
    contextData = args.contextData,
    contextDataSource = args.contextDataSource,
    _args$testManager = args.testManager,
    testManager = _args$testManager === void 0 ? getNullTestManager() : _args$testManager,
    _args$logger = args.logger,
    logger = _args$logger === void 0 ? getNullLogger() : _args$logger;
  //
  //
  var reader = getSitecoreContextDataReader(contextDataSource);
  var page = reader === null || reader === void 0 ? void 0 : reader.getPageDetails(contextData);
  var definitions = reader === null || reader === void 0 ? void 0 : reader.getDefinitions(contextData);
  var item = reader === null || reader === void 0 ? void 0 : reader.getPageDetails(contextData);
  //
  //
  var args2 = {
    definitions: definitions,
    item: item,
    logger: logger
  };
  var ruleManager = getSitecorePersonalizationRuleManager(args2);
  //
  //
  var subscriptions = getSubscriptionManager("".concat(id, "_SUBS"), false, logger);
  //
  //
  function doPersonalize(rendering, triggeredTriggers) {
    var _a;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
      var rules, rule, result, includedInTest, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (rendering) {
              _context.n = 1;
              break;
            }
            logger.error('Sitecore personalization manager - No rendering was specified.');
            return _context.a(2);
          case 1:
            if (!disabled) {
              _context.n = 2;
              break;
            }
            logger.debug('Sitecore personalization manager - Personalization is disabled.');
            return _context.a(2);
          case 2:
            if (ruleManager) {
              _context.n = 3;
              break;
            }
            logger.debug('Sitecore personalization manager - No rule manager is configured.');
            return _context.a(2);
          case 3:
            rules = ruleManager.getRulesForRendering(rendering);
            if (!(!rules || rules.length == 0)) {
              _context.n = 4;
              break;
            }
            logger.debug('Sitecore personalization manager - No rules were resolved for the rendering.', {
              rendering: rendering.uid
            });
            return _context.a(2);
          case 4:
            //
            //Set to loading before applying the rules
            subscriptions.publish({
              component: rendering.uid,
              isLoading: true,
              page: page,
              type: 'state-changed',
              when: new Date()
            });
            _context.p = 5;
            _context.n = 6;
            return ruleManager.getFirstMatchingRule(rendering, triggeredTriggers);
          case 6:
            rule = _context.v;
            if (rule) {
              _context.n = 7;
              break;
            }
            logger.debug('Sitecore personalization manager - No personalization rule found that applies to the rendering.', {
              rendering: rendering.uid
            });
            subscriptions.publish({
              component: rendering.uid,
              isLoading: false,
              page: page,
              type: 'state-changed',
              when: new Date()
            });
            return _context.a(2);
          case 7:
            logger.debug('Sitecore personalization manager - Will run the actions associated with the rule.', {
              rule: rule,
              rendering: rendering.uid
            });
            _context.n = 8;
            return ruleManager.runRuleActions(rule, rendering);
          case 8:
            result = _context.v;
            includedInTest = (_a = testManager === null || testManager === void 0 ? void 0 : testManager.getIsIncludedInTest()) !== null && _a !== void 0 ? _a : false; //
            //Publish a state-changed event to notify components that
            //personalization is done loading and that there may be
            //changes to render.
            logger.debug('Sitecore personalization manager - Result of running the rule actions.', {
              result: result,
              rule: rule,
              rendering: rendering.uid
            });
            subscriptions.publish({
              changes: result.changes,
              component: rendering.uid,
              includedInTest: includedInTest,
              isLoading: false,
              page: page,
              personalizedData: result.fields,
              rule: rule,
              type: 'state-changed',
              when: new Date()
            });
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
            subscriptions.publish({
              component: rendering.uid,
              error: _t,
              isLoading: false,
              page: page,
              type: 'state-changed',
              when: new Date()
            });
            return _context.a(2);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[5, 9]]);
    }));
  }
  //
  //
  var manager = {
    id: id,
    disabled: disabled,
    page: page,
    subscriptions: subscriptions,
    triggers: ruleManager === null || ruleManager === void 0 ? void 0 : ruleManager.triggers,
    testManager: testManager,
    onTrigger: function onTrigger(trigger, rendering) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              doPersonalize(rendering, [trigger]);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
    },
    personalize: function personalize(rendering) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              doPersonalize(rendering);
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
    }
  };
  return manager;
}